import Route from '@ember/routing/route';

export default class EmployeesDirectoryIndexRoute extends Route {
  resetController(controller, isExiting) {
    if (isExiting) {
      this.send('resetQueryParams');
    }
  }
}
